import Axios from 'axios';
import Qs from 'qs';
import { Exception, ExceptionCode } from '@konv/exceptions';
import { Response } from "@konv/http";

Axios.interceptors.request.use(config => {
    config.paramsSerializer = params => {
        // Qs is already included in the Axios package
        return Qs.stringify(params, {
            arrayFormat: "brackets",
            encode: true
        });
    };
    return config;
});

export class RequestClass {
    http_client = null;
    general_headers = [];
    _base_url = null;

    constructor(base_url) {
        this._base_url = base_url;
        this.http_client = Axios;
    }

    get base_url() {
        const services_endpoint = [
            this._base_url,
            process.env.ECS_SERVICES_ENDPOINT_BASE,
            process.env.SERVICES_ENDPOINT_BASE,
            process.env.REACT_APP_SERVICES_ENDPOINT_BASE,
            process.env.NEXT_PUBLIC_SERVICES_ENDPOINT_BASE
        ];

        return services_endpoint.find(u => !!u) || null;
    }

    async request(data) {
        const service_address = this.loadServiceAddress(
            `olga/request/${data.service}` || "olga/request/storage",
            !data.ignoreVersion ? (data.version || 'v1') : false
        );

        const endpoint = data.endpoint || '/';

        delete data.endpoint;
        delete data.ignoreVersion;

        const headers = data['headers'] || { ...this.general_headers };

        if (data.pagination) {
            if (data.pagination.page) {
                headers['x-pagination-index'] = data.pagination.page;
            }
            if (data.pagination.limit) {
                headers['x-pagination-limit'] = data.pagination.limit;
            }
            if (data.pagination.order) {
                headers['x-pagination-order'] = data.pagination.order;
            }
            if (data.pagination.direction) {
                headers['x-pagination-direction'] = data.pagination.direction;
            }
            if (data.pagination.disabled) {
                headers['x-pagination-disabled'] = data.pagination.disabled;
            }
        }

        data = Object.assign({
            crossdomain: true,
            url: `${service_address}${endpoint}`,
            headers
        }, data);

        data.headers['Content-Type'] = 'application/json';

        try {
            const response = await this.http_client(data);
            const result = response?.data?.response || response?.data;
            return new Response(
                result?.data || null,
                result?.code || 200,
                result?.errors || [],
                result?.pagination || null
            );
        } catch (err) {
            const result = err?.response?.data?.response;

            if (result?.errors?.length > 0) {
                return new Response(
                    result?.data || null,
                    result?.code || 1000,
                    result?.errors,
                    result?.pagination || null
                );
            }

            const errorMessage = `Falha na comunicação: ${err.message.toLowerCase()}`
            return new Response(
                result?.data || null,
                result?.code || 1000,
                [errorMessage],
                result?.pagination || null
            );
        }

    }

    get(data) {
        return this.request({ ...data, method: 'get' })
    }

    put(data) {
        return this.request({ ...data, method: 'put' })
    }

    post(data) {
        return this.request({ ...data, method: 'post' })
    }

    patch(data) {
        return this.request({ ...data, method: 'patch' })
    }

    delete(data) {
        return this.request({ ...data, method: 'delete' })
    }

    setHeader(header, value) {
        this.general_headers[header] = value
    }

    setHeaders(headers_array = []) {
        Object.keys(headers_array).map((key) => {
            this.setHeader(key, headers_array[key]);
        });
    }

    loadServiceAddress(service_name, version) {
        const services_endpoint = this.base_url;
        if (services_endpoint) {
            const url = services_endpoint.replace('{SERVICE}', service_name).replace('{STAGE}', process.env.STAGE).toLowerCase();
            return `${url}${version ? '/' + version.toLowerCase() : ''}`
        } else {
            throw new Exception(ExceptionCode.ENVIRONMENT_ENDPOINT_UNDEFINED);
        }
    }
}